import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useMixpanel } from 'react-mixpanel-browser';

import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';
import { PRICING_DATETIME_FORMAT } from '../../../constants/dateFormats';
import { sizeFormatter } from '../../graphs/utils';
import { RowStatus } from './RowStatus';
import { DownloadReportIcon } from '../../icons/analytics';
import { REPORTS_MANAGER_STATUSES, REPORTS_MANAGER_TYPES, REPORTS_MANAGER_TYPES_DISPLAY_NAME } from './consts';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';

import styles from './ReportsManagerTable.module.scss';

export function ReportsManagerRow(props) {
  const { row } = props;
  const { name: supplierName } = useSelector((state) => state.role.supplier);
  const mixpanel = useMixpanel();
  const reportBi = (event, meta) => {
    reportBusinessActionToMixpanel(mixpanel, event, meta);
  };

  return (
    <tr className={styles.reportsManagerRow}>
      <td>{REPORTS_MANAGER_TYPES_DISPLAY_NAME[REPORTS_MANAGER_TYPES[row.type]]}</td>
      <td>{row.reportFile?.name ?? NO_VALUE_PLACEHOLDER}</td>
      <td>{sizeFormatter(row.reportFile?.size ?? NO_VALUE_PLACEHOLDER)}</td>
      <td>{format(new Date(row.createdAt), PRICING_DATETIME_FORMAT)}</td>
      <td className={styles.status}>
        <RowStatus status={row.status} />
      </td>
      <td className={styles.actions}>
        {row.status === REPORTS_MANAGER_STATUSES.ready && (
          <button
            onClick={() => {
              reportBi('report-manager-download', { supplierName, reportType: row.type });
              window.open(row.reportFile.url);
            }}
          >
            <DownloadReportIcon />
          </button>
        )}
      </td>
    </tr>
  );
}

ReportsManagerRow.propTypes = {
  row: PropTypes.shape({
    type: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    reportFile: PropTypes.shape({
      name: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
    }),
  }).isRequired,
};
